import { ReactComponent as Campaigns } from 'App/assets/img/campaign-icon.svg';
import { ReactComponent as Candidates } from 'App/assets/img/candidatos-icon.svg';
import { ReactComponent as Personas } from 'App/assets/img/collaborator-icon.svg';
import { ReactComponent as Dashboard } from 'App/assets/img/dashboard_outline.svg';
import { ReactComponent as Files } from 'App/assets/img/file-menu.svg';
import { ReactComponent as Home } from 'App/assets/img/home.svg';
import { ReactComponent as Hra } from 'App/assets/img/hra-icon.svg';
import { ReactComponent as JobProfile } from 'App/assets/img/job-profile.svg';
import { ReactComponent as Nom024 } from 'App/assets/img/nom024.svg';
import { ChangePassword } from 'App/Components/ChangePassword/ChangePassword';
import { FiEye, FiInfo, FiKey } from 'react-icons/fi';
import { SystemInfoModal } from './components/SystemInfoModal/SystemInfoModal';
import { MdOutlineManageAccounts } from 'react-icons/md';
import { TbLogout } from 'react-icons/tb';

export const sidebarOptions = [
	{
		active: true,
		label: 'Home',
		slug: 'panel1',
		url: '/',
		icon: Home,
		child: [],
	},
	{
		active: true,
		label: 'Dashboard',
		slug: 'panel2',
		url: '/dashboard',
		icon: Dashboard,
		child: [],
	},
	{
		active: true,
		label: 'Campañas',
		slug: 'panel3',
		url: '/campaigns',
		icon: Campaigns,
		child: [],
	},
	{
		active: true,
		label: 'Colaboradores',
		slug: 'panel4',
		icon: Personas,
		url: '/employees',
		child: [],
	},
	{
		active: true,
		label: 'Candidatos',
		slug: 'panel5',
		icon: Candidates,
		url: '/candidates',
		child: [],
	},
	{
		active: true,
		label: 'Archivos',
		slug: 'panel6',
		icon: Files,
		url: '/files',
		child: [],
	},
	{
		active: true,
		label: 'Perfiles de puesto',
		slug: 'panel7',
		icon: JobProfile,
		url: '/job-profile',
		child: [],
	},
	{
		active: true,
		label: 'HRA',
		slug: 'panel8',
		icon: Hra,
		url: '/health-risk-assessment',
		child: [],
	},
	{
		active: true,
		label: 'NOM-024',
		slug: 'panel9',
		icon: Nom024,
		url: '/report-nom',
		child: [],
	},
];

export const navbarMenuOptions = [
	{ type: 'systemInfo', label: 'Informaciones del sistema', icon: FiInfo },
	{ type: 'password', label: 'Cambiar contraseña', icon: FiEye },
	{
		type: 'user',
		label: 'Gestión de accesos',
		icon: MdOutlineManageAccounts,
	},
	{ type: 'signout', label: 'Cerrar sesión', icon: TbLogout },
];

export const modalConfig = {
	password: {
		icon: FiKey,
		width: '360px',
		component: ChangePassword,
	},
	systemInfo: {
		icon: FiInfo,
		width: '360px',
		component: SystemInfoModal,
	},
};
